import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./CustomizedDialog.scss";

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

interface CustomizedDialogProps {
  onClose: () => void;
  isOpen: boolean;
  children: any;
  title: string;
  onSubmit: () => void;
  loading?: boolean;
}

export default function CustomizedDialog(props: CustomizedDialogProps) {
  const { onClose, isOpen, children, title, onSubmit, loading } = props;
  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        maxWidth="lg"
        className="customized-dialog"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {title}
        </BootstrapDialogTitle>
        <DialogContent dividers>{children}</DialogContent>
        <DialogActions>
          <Button color={"error"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={loading}
            autoFocus
            color={"success"}
            variant="contained"
            style={{
              color: "white",
            }}
            onClick={onSubmit}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
